import React from "react";
import { NoSettings } from "./sectionFormKit";

// Customer: components/sections/ForgotPassword/ForgotPassword.js
const ForgotPassword = () => <NoSettings text="Forgot password form. No settings." />;

export default ForgotPassword;
